"use client";

import { RenderIf } from "./render-if";
import { Heading, HeadingProps } from "../ui/heading";
import { cn } from "@/lib/utils";

export type SeoHeadingProps = {
  seoHeading?: string;
  heading?: string;
  as?: "h1" | "h2";
  headingProps?: Omit<HeadingProps, "children">;
  seoHeadingProps?: Omit<HeadingProps, "children">;
};

export const SeoHeading = ({
  seoHeading,
  heading,
  as = "h2",
  headingProps,
  seoHeadingProps,
}: SeoHeadingProps) => {
  return (
    <>
      <RenderIf condition={!!seoHeading}>
        <Heading
          as={as}
          {...seoHeadingProps}
          className={cn(
            "font-semi-bold text-muted-foreground mb-1.5 text-sm uppercase",
            seoHeadingProps?.className
          )}
        >
          {seoHeading}
        </Heading>
      </RenderIf>
      <RenderIf condition={!!heading}>
        <Heading
          as={as}
          {...(seoHeading && { render: <div /> })}
          {...headingProps}
          className={cn("mb-3", headingProps?.className)}
        >
          {heading}
        </Heading>
      </RenderIf>
    </>
  );
};
